import { render, staticRenderFns } from "./DomainOpposition.vue?vue&type=template&id=10cfe6d5&"
import script from "./DomainOpposition.vue?vue&type=script&lang=js&"
export * from "./DomainOpposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports